import React__default, { useContext } from 'react';
import { a as LocalizationContext } from '../LocalizationContext-a82461b5.js';
import { a as UserProfileContext } from '../UserProfileContext-f3f446d2.js';
import { getCreateGroupChannel } from '../sendbirdSelectors.js';
import Avatar from './Avatar.js';
import { L as Label, a as LabelTypography, b as LabelColors } from '../index-6420013c.js';
import Button, { ButtonTypes } from './Button.js';
import useSendbirdStateContext from '../useSendbirdStateContext.js';
import '../stringSet-b60e9529.js';
import '../index-6add7940.js';
import 'prop-types';
import '../_rollupPluginBabelHelpers-05128ded.js';
import '../topics-eb548880.js';
import '../utils-e0c7329c.js';
import './ImageRenderer.js';
import './Icon.js';
import '../uuid-717930b4.js';
import '../withSendbird.js';
function UserProfile(_ref) {
  var _store$config, _store$config2;
  var user = _ref.user,
    currentUserId = _ref.currentUserId,
    _ref$disableMessaging = _ref.disableMessaging,
    disableMessaging = _ref$disableMessaging === void 0 ? false : _ref$disableMessaging,
    onSuccess = _ref.onSuccess;
  var store = useSendbirdStateContext();
  var createChannel = getCreateGroupChannel(store);
  var logger = store === null || store === void 0 ? void 0 : (_store$config = store.config) === null || _store$config === void 0 ? void 0 : _store$config.logger;
  var _useContext = useContext(LocalizationContext),
    stringSet = _useContext.stringSet;
  var currentUserId_ = currentUserId || (store === null || store === void 0 ? void 0 : (_store$config2 = store.config) === null || _store$config2 === void 0 ? void 0 : _store$config2.userId);
  // @ts-ignore
  var _useContext2 = useContext(UserProfileContext),
    onUserProfileMessage = _useContext2.onUserProfileMessage;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird__user-profile"
  }, /*#__PURE__*/React__default.createElement("section", {
    className: "sendbird__user-profile-avatar"
  }, /*#__PURE__*/React__default.createElement(Avatar, {
    height: "80px",
    width: "80px",
    src: user === null || user === void 0 ? void 0 : user.profileUrl
  })), /*#__PURE__*/React__default.createElement("section", {
    className: "sendbird__user-profile-name"
  }, /*#__PURE__*/React__default.createElement(Label, {
    type: LabelTypography.H_2,
    color: LabelColors.ONBACKGROUND_1
  }, (user === null || user === void 0 ? void 0 : user.nickname) || stringSet.NO_NAME)), (user === null || user === void 0 ? void 0 : user.userId) !== currentUserId_ && !disableMessaging && /*#__PURE__*/React__default.createElement("section", {
    className: "sendbird__user-profile-message"
  }, /*#__PURE__*/React__default.createElement(Button, {
    type: ButtonTypes.SECONDARY,
    onClick: function onClick() {
      // Create 1:1 channel
      var params = {
        isDistinct: false,
        invitedUserIds: [user === null || user === void 0 ? void 0 : user.userId],
        operatorUserIds: [currentUserId_]
      };
      onSuccess();
      createChannel(params).then(function (groupChannel) {
        logger.info('UserProfile, channel create', groupChannel);
        if (typeof onUserProfileMessage === 'function') {
          onUserProfileMessage === null || onUserProfileMessage === void 0 ? void 0 : onUserProfileMessage(groupChannel);
        }
      });
    }
  }, stringSet.USER_PROFILE__MESSAGE)), /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird__user-profile-separator"
  }), /*#__PURE__*/React__default.createElement("section", {
    className: "sendbird__user-profile-userId"
  }, /*#__PURE__*/React__default.createElement(Label, {
    className: "sendbird__user-profile-userId--label",
    type: LabelTypography.CAPTION_2,
    color: LabelColors.ONBACKGROUND_2
  }, stringSet.USER_PROFILE__USER_ID), /*#__PURE__*/React__default.createElement(Label, {
    className: "sendbird__user-profile-userId--value",
    type: LabelTypography.BODY_1,
    color: LabelColors.ONBACKGROUND_1
  }, user === null || user === void 0 ? void 0 : user.userId)));
}
export { UserProfile as default };